import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

export default function Login() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await fetch("/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ login, password }),
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.token);
        localStorage.setItem("username", login);
        navigate("/");
      } else {
        const err = await res.json();
        setError(err.error || "Ошибка авторизации");
      }
    } catch {
      setError("Ошибка сети");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-center text-gray-800">Вход в систему</h2>
          <div className="h-1 w-16 bg-primary mx-auto mt-2"></div>
        </div>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="login" className="block text-sm font-medium text-gray-700">
              Логин
            </label>
            <Input
              id="login"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              className="w-full"
              autoFocus
            />
          </div>
          
          <div className="space-y-2">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">
              Пароль
            </label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full"
            />
          </div>
          
          {error && (
            <p className="text-red-500 text-center mt-2">
              {error}
            </p>
          )}
          
          <Button
            type="submit"
            className="w-full bg-primary hover:bg-primary/90"
          >
            Войти
          </Button>
        </form>
        
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            Behavioral Factor Studio
          </p>
        </div>
      </div>
    </div>
  );
}
